import React, { useState, useEffect } from 'react';
import { Dialog, makeStyles } from '@material-ui/core';
import { v4 as uuidv4 } from 'uuid';
import { Trans, useTranslation } from 'react-i18next';

import ESquareRedirectCode from '../interfaces/ESquareRedirectCode';

import YoelloLockIcon from '../components/icon/YoelloLockIcon';
import SquareAuthorisationButton from './SquareAuthorisationButton';

const useStyles = makeStyles({
    root: {
        padding: "2rem",
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        alignItems: "center"
    },
    title: {
        fontSize: "1.25rem",
        textAlign: "center",
        fontWeight: 700,
        padding: "1rem"
    },
    description: {
        fontSize: "1rem",
        padding: "2rem",
        fontWeight: 500
    },
    descriptionBold: {
        fontWeight: 600
    }
})

const SquarePrompt = () => {
    const [ open, setOpen ] = useState(true);
    const { t } = useTranslation();
    const [ csrfToken, setCsrfToken ] = useState('');
    const storageToken = localStorage.getItem('square-csrf');
    const classes = useStyles();
    const handleClose = () => {
        setOpen(false);
    }

    useEffect(() => {
        const token = storageToken && storageToken.indexOf(`${ESquareRedirectCode.REAUTH}_`) > -1 ?
            storageToken :
            `${ESquareRedirectCode.REAUTH}_${uuidv4()}`;
        localStorage.setItem('square-csrf', token);
        setCsrfToken(token);
        //eslint-disable-next-line
    }, [])
    return (
        <Dialog
            open={open}
            onClose={handleClose}
        >
            <div className={classes.root}>
                <YoelloLockIcon />
                <div className={classes.title}>{t("signup.importer.revoked_title")}</div>
                <div className={classes.description}>
                    <Trans
                        i18nKey="signup.importer.revoked_description"
                    >
                        0 <span className={classes.descriptionBold}>1</span>
                    </Trans>
                </div>
                <SquareAuthorisationButton 
                    csrfToken={csrfToken}
                    enabledText={t("signup.importer.reauthorise")}
                    disabledText={t("signup.importer.connecting_square")}
                />
            </div>
        </Dialog>
    )
}

export default SquarePrompt;